{
  "labels": {
    "paste": "Lim inn",
    "pasteAsPlaintext": "",
    "pasteCharts": "Lim inn diagram",
    "selectAll": "Vel alt",
    "multiSelect": "Legg til element i utval",
    "moveCanvas": "Flytt lerretet",
    "cut": "Klipp ut",
    "copy": "Kopier",
    "copyAsPng": "Kopier til utklippstavla som PNG",
    "copyAsSvg": "Kopier til utklippstavla som SVG",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Flytt framover",
    "sendToBack": "Send heilt bak",
    "bringToFront": "Flytt heilt fram",
    "sendBackward": "Send bakover",
    "delete": "Slett",
    "copyStyles": "Kopier stilar",
    "pasteStyles": "Lim inn stilar",
    "stroke": "Strek",
    "changeStroke": "",
    "background": "Bakgrunn",
    "changeBackground": "",
    "fill": "Fyll",
    "strokeWidth": "Strekbreidd",
    "strokeStyle": "Strekstil",
    "strokeStyle_solid": "",
    "strokeStyle_dashed": "Stipla",
    "strokeStyle_dotted": "Prikka",
    "sloppiness": "Ujamnheit",
    "opacity": "Synlegheit",
    "textAlign": "Tekstjustering",
    "edges": "Kanter",
    "sharp": "Skarp",
    "round": "Rund",
    "arrowheads": "Pilhovud",
    "arrowhead_none": "Ingen",
    "arrowhead_arrow": "Pil",
    "arrowhead_bar": "Stolpe",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Trekant",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Skriftstorleik",
    "fontFamily": "Skrifttype",
    "addWatermark": "Legg til «Laga med Excalidraw»",
    "handDrawn": "Handteikna",
    "normal": "",
    "code": "Kode",
    "small": "Liten",
    "medium": "",
    "large": "Stor",
    "veryLarge": "Svært stor",
    "solid": "",
    "hachure": "Skravert",
    "zigzag": "",
    "crossHatch": "Krysskravert",
    "thin": "Tynn",
    "bold": "Tjukk",
    "left": "Venstre",
    "center": "Midstill",
    "right": "Høgre",
    "extraBold": "Ekstra tjukk",
    "architect": "Arkitekt",
    "artist": "Kunstnar",
    "cartoonist": "Teiknar",
    "fileTitle": "Filnamn",
    "colorPicker": "Fargeveljar",
    "canvasColors": "Brukt på lerretet",
    "canvasBackground": "Lerretsbakgrunn",
    "drawingCanvas": "Lerret",
    "clearCanvas": "",
    "layers": "Lag",
    "actions": "Handlingar",
    "language": "Språk",
    "liveCollaboration": "",
    "duplicateSelection": "Dupliser",
    "untitled": "Utan namn",
    "name": "Namn",
    "yourName": "Namnet ditt",
    "madeWithExcalidraw": "Laga med Excalidraw",
    "group": "Grupper utval",
    "ungroup": "Avgrupper utval",
    "collaborators": "Samarbeidarar",
    "toggleGrid": "",
    "addToLibrary": "Legg til i bibliotek",
    "removeFromLibrary": "Fjern frå bibliotek",
    "libraryLoadingMessage": "Laster bibliotek…",
    "libraries": "Blad gjennom bibliotek",
    "loadingScene": "Laster scene…",
    "loadScene": "",
    "align": "Juster",
    "alignTop": "Juster til topp",
    "alignBottom": "Juster til botn",
    "alignLeft": "Juster til venstre",
    "alignRight": "Juster til høgre",
    "centerVertically": "Midtstill vertikalt",
    "centerHorizontally": "Midtstill horisontalt",
    "distributeHorizontally": "Sprei horisontalt",
    "distributeVertically": "Sprei vertikalt",
    "flipHorizontal": "Vipp vassrett",
    "flipVertical": "Vipp loddrett",
    "viewMode": "Visningsmodus",
    "share": "Del",
    "showStroke": "Vis fargeveljar for linjer",
    "showBackground": "Vis fargeveljar for bakgrunn",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "Personleg bibliotek",
    "excalidrawLib": "Excalidraw-bibliotek",
    "decreaseFontSize": "Gjer skriftstorleik mindre",
    "increaseFontSize": "Gjer skriftstorleik større",
    "unbindText": "Avbind tekst",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "Rediger lenke",
      "editEmbed": "",
      "create": "",
      "label": "Lenke",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": "",
    "followUs": "Følg oss",
    "discordChat": "Discord chat",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": "",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Tilbakestill lerretet",
    "exportJSON": "Eksporter til fil",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "Kopier til utklippstavla",
    "copyLink": "",
    "save": "Lagre til noverande fil",
    "saveAs": "Lagre som",
    "load": "",
    "getShareableLink": "Hent delingslenke",
    "close": "Lukk",
    "selectLanguage": "Vel språk",
    "scrollBackToContent": "Skroll tilbake til innhald",
    "zoomIn": "Zoom inn",
    "zoomOut": "Zoom ut",
    "resetZoom": "Nullstill zoom",
    "menu": "Meny",
    "done": "Ferdig",
    "edit": "Rediger",
    "undo": "Angre",
    "redo": "Gjer om",
    "resetLibrary": "Nullstill bibliotek",
    "createNewRoom": "Lag nytt rom",
    "fullScreen": "Fullskjerm",
    "darkMode": "Mørk modus",
    "lightMode": "Lys modus",
    "systemMode": "",
    "zenMode": "Zen-modus",
    "objectsSnapMode": "",
    "exitZenMode": "Avslutt zen-modus",
    "cancel": "Avbryt",
    "saveLibNames": "",
    "clear": "Tøm",
    "remove": "Fjern",
    "embed": "",
    "publishLibrary": "",
    "submit": "Send inn",
    "confirm": "Stadfest",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Dette vil tømme lerretet. Er du sikker?",
    "couldNotCreateShareableLink": "Kunne ikkje lage delingslenke.",
    "couldNotCreateShareableLinkTooBig": "Kunne ikkje opprette deleleg lenke: scena er for stor",
    "couldNotLoadInvalidFile": "Kunne ikkje laste inn ugyldig fil",
    "importBackendFailed": "Importering av backend feila.",
    "cannotExportEmptyCanvas": "Kan ikkje eksportere eit tomt lerret.",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "Kunne ikkje dekryptere data.",
    "uploadedSecurly": "Opplastinga er kryptert og er ikkje mogleg å lese av Excalidraw-serveren eller tredjepartar.",
    "loadSceneOverridePrompt": "Innlasting av ekstern teikning erstattar ditt eksisterande innhald. Ynskjer du å fortsette?",
    "collabStopOverridePrompt": "Viss du avsluttar økta overskriv du den førre, lokalt lagra teikninga di. Er du sikker?\n\n(Ønsker du å halde fram med denne? Då er det berre å lukke denne fana.)",
    "errorAddingToLibrary": "Kunne ikkje legge elementet i biblioteket",
    "errorRemovingFromLibrary": "Kunne ikkje fjerne elementet frå biblioteket",
    "confirmAddLibrary": "Dette vil legge til {{numShapes}} form(er) i biblioteket ditt. Er du sikker?",
    "imageDoesNotContainScene": "Dette biletet ser ikkje ut til å ha noko scenedata. Har du skrutt på innbygging av scene medan eksporteringa heldt på?",
    "cannotRestoreFromImage": "Scena kunne ikkje gjenopprettast frå denne biletfila",
    "invalidSceneUrl": "Kunne ikkje hente noko scene frå den URL-en. Ho er anten øydelagd eller inneheld ikkje gyldig Excalidraw JSON-data.",
    "resetLibrary": "Dette vil fjerne alt innhald frå biblioteket. Er du sikker?",
    "removeItemsFromsLibrary": "Slette {{count}} element frå biblioteket?",
    "invalidEncryptionKey": "Krypteringsnøkkelen må ha 22 teikn. Sanntidssamarbeid er deaktivert.",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Filtypen er ikkje støtta.",
    "imageInsertError": "Kunne ikkje sette inn biletet. Prøv igjen seinare...",
    "fileTooBig": "Fila er for stor. Maksimal tillate storleik er {{maxSize}}.",
    "svgImageInsertError": "Kunne ikkje sette inn SVG-biletet. SVG-koden ser ugyldig ut.",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "Kunne ikkje kople til samarbeidsserveren. Ver vennleg å oppdatere inn sida og prøv på nytt.",
    "importLibraryError": "",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Vel",
    "lasso": "",
    "image": "Sett in bilete",
    "rectangle": "Rektangel",
    "diamond": "Diamant",
    "ellipse": "",
    "arrow": "Pil",
    "line": "Linje",
    "freedraw": "Teikn",
    "text": "Tekst",
    "library": "Bibliotek",
    "lock": "Hald fram med valt verktøy",
    "penMode": "",
    "link": "",
    "eraser": "Viskelêr",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Handlingar: lerret",
    "selectedShapeActions": "Handlingar: valt objekt",
    "shapes": "Formar"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Klikk for å starte linje med fleire punkt, eller drag for ei enkel linje",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Klikk og drag, slepp når du er ferdig",
    "text": "Tips: du kan òg leggje til tekst ved å dobbeltklikke kor som helst med utvalgsverktyet",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Publiser ditt eige bibliotek",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Kan ikkje vise førehandsvising",
    "canvasTooBig": "Lerretet er mogleg for stort.",
    "canvasTooBigTip": "Tips: prøv å flytte elementa som er lengst frå kvarandre, litt nærare kvarandre."
  },
  "errorSplash": {
    "headingMain": "Ein feil oppstod. Prøv <button>å laste sida på nytt.</button>",
    "clearCanvasMessage": "Om ny sidelasting ikkje fungerer, prøv <button>å tømme lerretet.</button>",
    "clearCanvasCaveat": " Dette vil føre til tap av arbeid ",
    "trackedToSentry": "Feilen med identifikator {{eventId}} vart logga i systemet vårt.",
    "openIssueMessage": "Vi er veldig nøye med å ikkje inkludere scene-opplysingane dine i feilmeldinga. Viss scena di ikkje er privat kan du vurdere å følge opp i <button>feilrapporteringssystemet vårt.</button> Ta med opplysingane nedanfor ved å kopiere og lime inn i GitHub-saka.",
    "sceneContent": "Scene-innhald:"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Start økt",
    "button_stopSession": "Stopp økt",
    "desc_inProgressIntro": "Sanntids-samarbeidsøkt er no i gang.",
    "desc_shareLink": "Del denne lenka med dei du vil samarbeide med:",
    "desc_exitSession": "Dersom du avsluttar økta blir du kopla frå rommet, men du kan halde fram med å arbeide med scena lokalt. Ver merksam på at dette ikkje vil påverke andre personar, og desse vil framleis ha moglegheit til å samarbeide på deira eigen versjon.",
    "shareTitle": "Bli med på eit sanntidssamarbeid på Excalidraw"
  },
  "errorDialog": {
    "title": "Feil"
  },
  "exportDialog": {
    "disk_title": "Lagre til disk",
    "disk_details": "Eksporter scenedataa til ei fil du kan importere seinare.",
    "disk_button": "Lagre til fil",
    "link_title": "Deleleg lenke",
    "link_details": "Eksporter som skrivebeskytta lenke.",
    "link_button": "Eksporter til lenke",
    "excalidrawplus_description": "Lagre scena til Excalidraw+-arbeidsområdet ditt.",
    "excalidrawplus_button": "Eksporter",
    "excalidrawplus_exportError": "Kunne ikkje eksportere til Excalidraw+ akkurat no..."
  },
  "helpDialog": {
    "blog": "Les bloggen vår",
    "click": "klikk",
    "deepSelect": "Marker djupt",
    "deepBoxSelect": "Marker djupt inni boksen og forhindr flytting",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Boga pil",
    "curvedLine": "Boga linje",
    "documentation": "Dokumentasjon",
    "doubleClick": "dobbelklikk",
    "drag": "",
    "editor": "Redigering",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Funne eit problem? Send inn",
    "howto": "Følg vegleiinga vår",
    "or": "eller",
    "preventBinding": "Hindre pilkopling",
    "tools": "",
    "shortcuts": "Tastatursnarvegar",
    "textFinish": "Fullfør redigering (teksthandsamar)",
    "textNewLine": "Legg til ny linje (teksthandsamar)",
    "title": "Hjelp",
    "view": "Vising",
    "zoomToFit": "Zoom for å sjå alle elementa",
    "zoomToSelection": "Zoom til utval",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Tøm lerretet"
  },
  "publishDialog": {
    "title": "Publiser bibliotek",
    "itemName": "Elementnamn",
    "authorName": "Eigaren sitt namn",
    "githubUsername": "GitHub-brukarnamn",
    "twitterUsername": "Twitter-brukarnamn",
    "libraryName": "Biblioteknamn",
    "libraryDesc": "Bibliotekskildring",
    "website": "Nettstad",
    "placeholder": {
      "authorName": "Namnet eller brukarnamnet ditt",
      "libraryName": "Namnet på biblioteket ditt",
      "libraryDesc": "Skildring av biblioteket ditt sånn at andre forstår bruken av det",
      "githubHandle": "GitHub-brukarnamn (valfritt), slik at du kan redigere bibiloteket når det er sendt inn til vurdering",
      "twitterHandle": "Twitter-brukarnamn (valfritt), så vi veit kven vi skal kreditere på Twitter",
      "website": "Lenke til den personlege nettstaden din eller ein anna stad (valfritt)"
    },
    "errors": {
      "required": "Kravt",
      "website": "Fyll inn ein gyldig URL"
    },
    "noteDescription": "Send inn biblioteket ditt til inkludering i <link>den offentlege bibliotek-kjeldekoda</link>slik at andre kan bruke det i teikningane deira.",
    "noteGuidelines": "Biblioteket må godkjennast manuelt fyrst. Ver vennleg å lese <link>retningslinjene</link> før du sender inn. Du kjem til å trenge ein GitHub-konto for å kommunisere og gjere endringar dersom kravt, men det er ikkje strengt naudsynt.",
    "noteLicense": "Ved å sende inn godkjenner du at biblioteket vert publisert under <link>MIT-lisensen, </link>som kort sagt betyr at kven som helst kan bruke det utan avgrensingar.",
    "noteItems": "Kvart bibliotekselement må ha eit eige namn, slik at det er mogleg å filtrere. Dei følgande bibliotekselementa blir inkludert:",
    "atleastOneLibItem": "Ver vennleg å markere minst eitt bibliotekselement for å starte",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "Bibliotek innsendt",
    "content": "Tusen takk {{authorName}}! Biblioteket ditt har blitt sendt inn til gjennomgang. Du kan halde styr på status<link>her</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Tilbakestill bibliotek",
    "removeItemsFromLib": "Fjern valde element frå biblioteket"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Teikningane dine er ende-til-ende-krypterte slik at Excalidraw sine serverar aldri får sjå dei.",
    "link": "Blogginnlegg om ende-til-ende-kryptering i Excalidraw"
  },
  "stats": {
    "angle": "Vinkel",
    "shapes": "",
    "height": "Høgde",
    "scene": "",
    "selected": "Valde",
    "storage": "Lagring",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "Totalt",
    "version": "Versjon",
    "versionCopy": "Klikk for å kopiere",
    "versionNotAvailable": "Versjonen er ikkje tilgjengeleg",
    "width": "Breidde"
  },
  "toast": {
    "addedToLibrary": "Lagt til i bibliotek",
    "copyStyles": "Kopierte stilane.",
    "copyToClipboard": "Kopiert til utklippstavla.",
    "copyToClipboardAsPng": "Kopierte {{exportSelection}} til utklippstavla som PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Fila er lagra.",
    "fileSavedToFilename": "Lagra som {filename}",
    "canvas": "lerret",
    "selection": "val",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Gjennomsiktig",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
